/* eslint no-use-before-define: 0 */
import Rx from "rxjs/Rx";

/**
 * Public API:
 * - event areaFilterSelected$ {filter, row}
 */

const areaFilterSelectedSource = new Rx.Subject();
/**
 * {filter, row}
 */
export const areaFilterSelected$ = areaFilterSelectedSource.asObservable();

/**
 * indicates selected area filter
 */
const lastAreaFilter = {
    filter: null,
    row: null,
};

export class AreaFilterComponent {
    /**
     * @param {Object} node - Jquery node. Unique for every AreaFilterComponent class instance.
     * @param {Object} row - instance of parent AreaFiltersRowComponent.
     */
    constructor(node, row) {
        this.node = node;
        this.row = row;
        this.min = null;
        this.max = null;

        this.intialize();
    }

    intialize() {
        this.parseArgs();
        this.subscribeOnAreaFilterClicked$();
        this.subscribeOnAreaFilterSelected$();
    }

    parseArgs() {
        this.min = parseInt(this.node.data("min"), 10);
        this.max = parseInt(this.node.data("max"), 10);
    }

    subscribeOnAreaFilterSelected$() {
        const scope = this;

        areaFilterSelected$.subscribe((args) => {
            // eslint-disable-next-line eqeqeq
            if (args.row != this.row) return;
            if (args.filter === this) {
                setActiveVisualState();
            } else {
                setPassiveVisualState();
            }
        });

        function setActiveVisualState() {
            scope.node.find(".custom-area-filter-component-figure").addClass("active");
        }

        function setPassiveVisualState() {
            scope.node.find(".custom-area-filter-component-figure").removeClass("active");
        }
    }

    subscribeOnAreaFilterClicked$() {
        const scope = this;

        this.node.on("click", () => {
            const isSelectedFilterClicked = lastAreaFilter.filter === this && lastAreaFilter.row === this.row;
            if (isSelectedFilterClicked) {
                lastAreaFilter.filter = null;
                lastAreaFilter.row = null;
                fireSelectedNone();
            } else {
                lastAreaFilter.filter = this;
                lastAreaFilter.row = this.row;
                fireSelectedThis();
            }
        });

        function fireSelectedNone() {
            areaFilterSelectedSource.next({
                filter: null,
                row: scope.row,
            });
        }

        function fireSelectedThis() {
            areaFilterSelectedSource.next({
                filter: scope,
                row: scope.row,
            });
        }
    }
}
